import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { TokenStorageService } from './token-storage.service';
import { environment } from 'src/environments/environment';
import { Observable } from 'rxjs';
const API_URL = environment.apiUrl + 'academy-slider-image';

@Injectable({
  providedIn: 'root'
})
export class AcademysliderService {
  authtoken: string;
  private httpOptions;
  constructor(private http: HttpClient, private token: TokenStorageService) {
    this.authtoken = this.token.getToken();
    this.httpOptions = {
      Headers: new HttpHeaders()
        .set("Content-Type", "application/json")
        .set('Authorization', `Bearer ${this.authtoken}`)
    };
  }

  getAcademyslderList(query): Observable<any> {
    return this.http.get(API_URL + query, this.httpOptions);
  }

  addAcademySliderImage(data): Observable<any> {
    return this.http.post(API_URL, data, this.httpOptions);
  }
  updateAcademySlider(id, data): Observable<any> {
    return this.http.put(API_URL + '/' + id, data);
  }

}
